export default function videoImage() {
  $('.video').each(function () {
    new IntersectionObserver(
      (entries) =>
        entries.forEach(({ isIntersecting }) => {
          setTimeout(() => {
            const vid = $('.video');
            vid.trigger(isIntersecting ? 'play' : 'pause');
            vid.next('.image').toggleClass('opacity-0', isIntersecting);
          }, 500);
        }),
      {}
    ).observe(this);
  });
}
